import {create} from "@/api/rest";

const signUp = {
  signUp: async (data) => await create('/sign-up', data),
};

export default signUp;